/* xcard-theme.js v1777976537 */
/* ============================================================
   XCARD HK — COMPLETE THEME JAVASCRIPT
   ============================================================ */

(function() {
  'use strict';

  /* ── Cursor Glow — desktop only (skip on touch/mobile) ── */
  const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || window.matchMedia('(hover: none)').matches;
  const cursor = document.getElementById('cursor-glow');
  const cursorRing = document.getElementById('cursor-ring');
  if (cursor && !isTouchDevice) {
    let mx = 0, my = 0, cx = 0, cy = 0;
    document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });
    (function animCursor() {
      cx += (mx - cx) * 0.12;
      cy += (my - cy) * 0.12;
      cursor.style.left = cx + 'px';
      cursor.style.top  = cy + 'px';
      if (cursorRing) { cursorRing.style.left = cx + 'px'; cursorRing.style.top = cy + 'px'; }
      requestAnimationFrame(animCursor);
    })();
    document.querySelectorAll('a,button,.xc-btn,.xc-product-card,.xc-cat-card,.xc-trend-card,.xc-quick-card').forEach(el => {
      el.addEventListener('mouseenter', () => cursor.classList.add('cursor-large'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('cursor-large'));
    });
    document.addEventListener('click', () => {
      cursor.classList.add('cursor-click');
      setTimeout(() => cursor.classList.remove('cursor-click'), 400);
    });
  } else if (cursor) {
    // Touch device: hide cursor elements completely
    cursor.style.display = 'none';
    if (cursorRing) cursorRing.style.display = 'none';
  }

  /* ── Loader ── */
  window.addEventListener('load', () => {
    const loader = document.getElementById('xcLoader');
    if (loader) {
      setTimeout(() => {
        loader.style.opacity = '0';
        loader.style.pointerEvents = 'none';
        setTimeout(() => loader.remove(), 600);
      }, 2600);
    }
  });

  /* ── Particle Canvas ── */
  (function initParticles() {
    const canvas = document.getElementById('particle-canvas');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let W, H, particles = [];

    function resize() {
      W = canvas.width  = window.innerWidth;
      H = canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    class Particle {
      constructor() { this.reset(); }
      reset() {
        this.x = Math.random() * W;
        this.y = Math.random() * H;
        this.vx = (Math.random() - 0.5) * 0.3;
        this.vy = (Math.random() - 0.5) * 0.3 - 0.1;
        this.size = Math.random() * 1.5 + 0.3;
        this.alpha = Math.random() * 0.4 + 0.05;
        this.gold = Math.random() > 0.7;
      }
      update() {
        this.x += this.vx; this.y += this.vy;
        if (this.y < -5 || this.x < -5 || this.x > W + 5) this.reset();
      }
      draw() {
        ctx.save();
        ctx.globalAlpha = this.alpha;
        ctx.fillStyle = this.gold ? '#C9A962' : 'rgba(255,255,255,0.6)';
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    }

    for (let i = 0; i < 90; i++) particles.push(new Particle());

    function drawConnections() {
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const dist = Math.sqrt(dx*dx + dy*dy);
          if (dist < 100) {
            ctx.save();
            ctx.globalAlpha = (1 - dist/100) * 0.06;
            ctx.strokeStyle = '#C9A962';
            ctx.lineWidth = 0.5;
            ctx.beginPath();
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.stroke();
            ctx.restore();
          }
        }
      }
    }

    function loop() {
      ctx.clearRect(0, 0, W, H);
      drawConnections();
      particles.forEach(p => { p.update(); p.draw(); });
      requestAnimationFrame(loop);
    }
    loop();
  })();

  /* ── Header Scroll Behavior ── */
  (function initHeader() {
    const header = document.querySelector('.xc-header');
    if (!header) return;
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('scrolled', y > 20);
      lastY = y;
    }, { passive: true });
  })();

  /* ── Mobile Nav ── */
  (function initMobileNav() {
    const btn   = document.getElementById('xcMobileNavBtn');
    const nav   = document.getElementById('xcMobileNav');
    const close = document.getElementById('xcMobileNavClose');
    if (!btn || !nav) return;
    btn.addEventListener('click',   () => nav.classList.add('open'));
    if (close) close.addEventListener('click', () => nav.classList.remove('open'));
    nav.addEventListener('click', e => { if (e.target === nav) nav.classList.remove('open'); });
  })();

  /* ── Search Overlay ── */
  (function initSearch() {
    const openBtn  = document.getElementById('xcSearchBtn');
    const overlay  = document.getElementById('xcSearchOverlay');
    const closeBtn = document.getElementById('xcSearchClose');
    const input    = document.getElementById('xcSearchInput');
    if (!openBtn || !overlay) return;
    openBtn.addEventListener('click', () => {
      overlay.classList.add('open');
      setTimeout(() => input && input.focus(), 200);
    });
    if (closeBtn) closeBtn.addEventListener('click', () => overlay.classList.remove('open'));
    overlay.addEventListener('click', e => { if (e.target === overlay) overlay.classList.remove('open'); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') overlay.classList.remove('open'); });
  })();

  /* ── Language / Currency Toggles ── */
  document.querySelectorAll('.xc-lang-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.xc-lang-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* ── Ripple Effect on Buttons ── */
  document.querySelectorAll('.xc-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      const r = document.createElement('span');
      r.className = 'ripple';
      const rect = this.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height) * 2;
      r.style.cssText = `width:${size}px;height:${size}px;left:${e.clientX-rect.left-size/2}px;top:${e.clientY-rect.top-size/2}px;`;
      this.appendChild(r);
      setTimeout(() => r.remove(), 600);
    });
  });

  /* ── Scroll Reveal ── */
  (function initReveal() {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((en, i) => {
        if (en.isIntersecting) {
          const delay = parseFloat(en.target.dataset.delay || 0);
          setTimeout(() => en.target.classList.add('xc-visible'), delay * 1000);
          obs.unobserve(en.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.xc-reveal, .xc-reveal-left, .xc-reveal-right, .xc-reveal-scale').forEach((el, i) => {
      if (!el.dataset.delay) el.dataset.delay = (i % 6) * 0.08;
      obs.observe(el);
    });
  })();

  /* ── Counter Animation ── */
  function animateCounter(el) {
    const raw = el.textContent.replace(/[^0-9.]/g, '');
    const suffix = el.textContent.replace(/[0-9.,]/g, '');
    const target = parseFloat(raw);
    if (isNaN(target)) return;
    const start = performance.now();
    const duration = 1800;
    function step(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;
      el.textContent = (Number.isInteger(target) ? Math.round(current).toLocaleString() : current.toFixed(1)) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  const counterObs = new IntersectionObserver((entries) => {
    entries.forEach(en => {
      if (en.isIntersecting) {
        animateCounter(en.target);
        counterObs.unobserve(en.target);
      }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.xc-trust-stat__num, .xc-hero__stat-num').forEach(el => counterObs.observe(el));

  /* ── Announcement Bar Ticker (duplicate for seamless loop) ── */
  (function initTicker() {
    const strip = document.querySelector('.xc-announce__strip');
    if (!strip) return;
    const clone = strip.cloneNode(true);
    strip.parentElement.appendChild(clone);
  })();

  /* ── New Arrivals Carousel ── */
  (function initCarousel() {
    const track   = document.getElementById('xcArrivalsTrack');
    const prevBtn = document.getElementById('xcCarouselPrev');
    const nextBtn = document.getElementById('xcCarouselNext');
    if (!track) return;

    let current = 0;
    const cards = track.querySelectorAll('.xc-product-card');
    const visible = window.innerWidth > 1200 ? 4 : window.innerWidth > 768 ? 2 : 1;
    const total = Math.max(0, cards.length - visible);

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, total));
      const cardW = cards[0].offsetWidth + 20;
      track.style.transform = `translateX(-${current * cardW}px)`;
    }
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    // Auto-play
    let autoPlay = setInterval(() => goTo(current + 1 > total ? 0 : current + 1), 4000);
    track.addEventListener('mouseenter', () => clearInterval(autoPlay));
    track.addEventListener('mouseleave', () => {
      autoPlay = setInterval(() => goTo(current + 1 > total ? 0 : current + 1), 4000);
    });

    // Touch / drag
    let startX = 0, isDragging = false;
    track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; isDragging = true; }, { passive: true });
    track.addEventListener('touchend',   e => {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
      isDragging = false;
    });
  })();

  /* ── Market Trends Table Filter Buttons ── */
  document.querySelectorAll('.xc-filter-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      this.closest('.xc-trends-filters').querySelectorAll('.xc-filter-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ── Trending Tabs ── */
  (function initTabs() {
    const tabs = document.querySelectorAll('.xc-tab-btn');
    const grids = document.querySelectorAll('.xc-trending__grid[data-tab]');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        const target = tab.dataset.tab;
        grids.forEach(g => {
          g.style.display = (g.dataset.tab === target || !target) ? 'grid' : 'none';
        });
      });
    });
  })();

  /* ── Market Search Filter ── */
  (function initTableSearch() {
    const input = document.getElementById('xcMarketSearch');
    if (!input) return;
    input.addEventListener('input', function() {
      const q = this.value.toLowerCase();
      document.querySelectorAll('.xc-trend-row').forEach(row => {
        const name = row.querySelector('.xc-trend-row__name')?.textContent.toLowerCase() || '';
        row.style.display = name.includes(q) ? '' : 'none';
      });
    });
  })();

  /* ── AI Grading Upload ── */
  (function initUpload() {
    const area = document.getElementById('xcUploadArea');
    if (!area) return;
    const input = document.getElementById('xcFileInput');

    area.addEventListener('dragover',  e => { e.preventDefault(); area.classList.add('drag-over'); });
    area.addEventListener('dragleave', ()  => area.classList.remove('drag-over'));
    area.addEventListener('drop', e => {
      e.preventDefault();
      area.classList.remove('drag-over');
      handleFile(e.dataTransfer.files[0]);
    });
    area.addEventListener('click', () => input && input.click());
    if (input) input.addEventListener('change', e => handleFile(e.target.files[0]));

    function handleFile(file) {
      if (!file) return;
      area.innerHTML = `
        <div class="xc-upload-area__icon"><svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M4 12a8 8 0 018-8v2M20 12a8 8 0 01-8 8v-2" stroke="#C9A962" stroke-width="2" stroke-linecap="round"/><path d="M12 4l-2 2 2 2M12 20l2-2-2-2" stroke="#C9A962" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
        <div class="xc-upload-area__text"><strong>Analysing ${file.name}…</strong></div>`;
      setTimeout(() => {
        area.innerHTML = `
          <div class="xc-upload-area__icon"><svg viewBox="0 0 24 24" fill="none" width="20" height="20"><circle cx="12" cy="12" r="9" stroke="#4CAF74" stroke-width="2"/><path d="M7 12l4 4 6-6" stroke="#4CAF74" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>
          <div class="xc-upload-area__text"><strong style="color:var(--green-b)">AI Grade: 9.4 / 10 — Near Mint</strong><br>
          <span>Estimated PSA equivalent: PSA 9 · Est. value HKD 420–540</span></div>`;
      }, 2200);
    }
  })();

  /* ── Confidence Bar Animate ── */
  const confObs = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (en.isIntersecting) {
        const fill = en.target.querySelector('.xc-confidence__fill');
        if (fill) fill.style.width = fill.dataset.pct + '%';
        confObs.unobserve(en.target);
      }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.xc-confidence').forEach(el => confObs.observe(el));

  /* ── Cart Notification ── */
  (function initCart() {
    const notif = document.getElementById('xcCartNotif');
    const closeBtn = document.querySelector('.xc-cart-notif__close');
    if (closeBtn && notif) closeBtn.addEventListener('click', () => notif.classList.remove('show'));

    document.querySelectorAll('.xc-product-card__add, [data-add-cart]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        const card = this.closest('.xc-product-card');
        const name = card?.querySelector('.xc-product-card__name')?.textContent || 'Card';
        const price = card?.querySelector('.xc-product-card__price')?.textContent || '';
        if (notif) {
          notif.querySelector('.xc-cart-notif__text strong').textContent = 'Added to Cart';
          notif.querySelector('.xc-cart-notif__text span').textContent = `${name} · ${price}`;
          notif.classList.add('show');
          setTimeout(() => notif.classList.remove('show'), 3500);
        }
        // Update badge
        const badge = document.querySelector('.xc-icon-btn .badge');
        if (badge) badge.textContent = parseInt(badge.textContent || '0') + 1;
      });
    });
  })();

  /* ── Quick View Modal ── */
  (function initQuickView() {
    document.querySelectorAll('[data-quickview]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation();
        const card = this.closest('.xc-product-card');
        const name  = card?.querySelector('.xc-product-card__name')?.textContent || 'Card';
        const price = card?.querySelector('.xc-product-card__price')?.textContent || '';
        const grade = card?.querySelector('.xc-product-card__grade')?.textContent || '';
        const emoji = card?.querySelector('.xc-product-card__emoji')?.textContent || '';

        const modal = document.createElement('div');
        modal.className = 'xc-modal-overlay';
        modal.innerHTML = `
          <div class="xc-modal">
            <button class="xc-modal__close" onclick="this.closest('.xc-modal-overlay').remove()"><svg viewBox="0 0 20 20" fill="none" width="14" height="14"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>
            <div class="xc-modal__emoji">${emoji}</div>
            <div class="xc-modal__grade">${grade}</div>
            <h3 class="xc-modal__name">${name}</h3>
            <div class="xc-modal__price">${price}</div>
            <button class="xc-btn xc-btn--primary" style="width:100%;margin-top:20px;justify-content:center;">Add to Cart</button>
          </div>`;
        document.body.appendChild(modal);
        requestAnimationFrame(() => modal.classList.add('open'));
        modal.addEventListener('click', e => { if (e.target === modal) modal.remove(); });
      });
    });
  })();

  /* ── SVG Price Chart Animation ── */
  (function initCharts() {
    document.querySelectorAll('.xc-chart-path').forEach(path => {
      const length = path.getTotalLength?.() || 300;
      path.style.strokeDasharray  = length;
      path.style.strokeDashoffset = length;
      path.style.transition = 'stroke-dashoffset 2s ease';

      const obs = new IntersectionObserver(entries => {
        entries.forEach(en => {
          if (en.isIntersecting) {
            path.style.strokeDashoffset = '0';
            obs.unobserve(en.target);
          }
        });
      }, { threshold: 0.5 });
      obs.observe(path);
    });
  })();

  /* ── Newsletter Form ── */
  (function initNewsletter() {
    const form = document.getElementById('xcNewsletterForm');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const input = this.querySelector('input[type="email"]');
      const btn   = this.querySelector('button');
      if (!input?.value) return;
      btn.textContent = 'Subscribed!';
      btn.style.background = 'var(--green-b)';
      btn.style.color = 'var(--white)';
      input.value = '';
      setTimeout(() => {
        btn.textContent = 'Subscribe';
        btn.style.background = '';
        btn.style.color = '';
      }, 3000);
    });
  })();

  /* ── Float Card 3D Tilt ── */
  document.querySelectorAll('.xc-float-card').forEach(card => {
    card.addEventListener('mousemove', function(e) {
      const rect = this.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width  - 0.5;
      const y = (e.clientY - rect.top)  / rect.height - 0.5;
      this.style.transform = `perspective(600px) rotateY(${x*20}deg) rotateX(${-y*20}deg) scale(1.06)`;
    });
    card.addEventListener('mouseleave', function() {
      this.style.transform = '';
    });
  });

  /* ── Product Card 3D Tilt ── */
  document.querySelectorAll('.xc-product-card').forEach(card => {
    card.addEventListener('mousemove', function(e) {
      const rect = this.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width  - 0.5;
      const y = (e.clientY - rect.top)  / rect.height - 0.5;
      this.style.transform = `perspective(800px) rotateY(${x*8}deg) rotateX(${-y*8}deg) translateY(-6px) scale(1.02)`;
    });
    card.addEventListener('mouseleave', function() {
      this.style.transform = '';
    });
  });

  /* ── Trending table live price flicker ── */
  (function initLivePrices() {
    const prices = document.querySelectorAll('.xc-trend-row__price');
    setInterval(() => {
      const target = prices[Math.floor(Math.random() * prices.length)];
      if (!target) return;
      const orig = target.textContent;
      const num  = parseFloat(orig.replace(/[^0-9.]/g, ''));
      if (isNaN(num)) return;
      const delta = (Math.random() - 0.4) * 5;
      const newNum = Math.max(1, num + delta).toFixed(0);
      target.textContent = 'HKD ' + Number(newNum).toLocaleString();
      target.style.color = delta > 0 ? 'var(--green-b)' : 'var(--red-b)';
      setTimeout(() => { target.style.color = ''; }, 600);
    }, 2800);
  })();

  /* ── Sparkline bar random animation seed ── */
  document.querySelectorAll('.spark-bar').forEach((bar, i) => {
    bar.style.height = (Math.random() * 18 + 6) + 'px';
  });

  /* ── Modal CSS (injected) ── */
  const style = document.createElement('style');
  style.textContent = `
    .xc-modal-overlay {
      position:fixed;inset:0;z-index:10000;
      background:rgba(0,0,0,0.85);backdrop-filter:blur(12px);
      display:flex;align-items:center;justify-content:center;
      opacity:0;transition:opacity 0.3s;
    }
    .xc-modal-overlay.open{opacity:1;}
    .xc-modal {
      background:var(--charcoal);border:1px solid var(--border);
      border-radius:var(--radius-xl);padding:36px;
      max-width:360px;width:90%;position:relative;
      transform:scale(0.9);transition:transform 0.3s;text-align:center;
    }
    .xc-modal-overlay.open .xc-modal{transform:scale(1);}
    .xc-modal__close {
      position:absolute;top:16px;right:16px;
      background:none;border:1px solid var(--border);
      border-radius:8px;padding:6px 10px;
      color:var(--gray);cursor:pointer;font-size:0.85rem;
    }
    .xc-modal__emoji{font-size:3rem;margin-bottom:12px;}
    .xc-modal__grade{
      display:inline-block;padding:4px 12px;border-radius:6px;
      background:var(--gold);color:var(--black);
      font-size:0.7rem;font-weight:800;margin-bottom:12px;
    }
    .xc-modal__name{font-size:1.1rem;font-weight:700;color:var(--white);margin-bottom:8px;}
    .xc-modal__price{font-size:1.4rem;font-weight:700;color:var(--gold);font-family:var(--font-display);}
  `;
  document.head.appendChild(style);

  console.log('%c XCARD HK Theme Loaded', 'color:#C9A962;font-size:14px;font-weight:bold;');
})();


/* PO-BTN WHATSAPP FIX v4 — redirect all preorder buttons to WhatsApp */
(function fixPreorderButtons(){
  var WA = 'https://wa.me/85290218503?text=';

  function applyFix(){
    document.querySelectorAll('a.po-btn').forEach(function(btn){
      var h = btn.getAttribute('href') || '';
      if(h.indexOf('wa.me') !== -1) return; // already fixed
      
      // Get product title from parent card
      var card = btn.closest('.po-card');
      var titleEl = card ? card.querySelector('.po-title') : null;
      var title = titleEl ? titleEl.textContent.trim() : '產品';
      var label = btn.textContent.trim();
      
      var msg;
      if(label === '查詢代購'){
        msg = encodeURIComponent('你好，我想查詢代購：' + title + '，請問詳情？');
      } else if(label === '登記通知'){
        msg = encodeURIComponent('你好，我想登記通知：' + title + '，有貨時請通知我。');
      } else {
        msg = encodeURIComponent('你好，我想預購：' + title + '，請問現在還有位嗎？');
      }
      btn.href = WA + msg;
      btn.target = '_blank';
      btn.rel = 'noopener noreferrer';
    });
  }

  // Run immediately and after DOM ready
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', applyFix);
  } else {
    applyFix();
  }
  // Also run after a short delay to catch dynamically rendered content
  setTimeout(applyFix, 500);
  setTimeout(applyFix, 1500);
})();


/* CONTACT PAGE CSS LEAK FIX v1 — wrap leaked raw CSS text in style tag */
(function fixContactPageCSSLeak(){
  if(window.location.pathname.indexOf('/pages/contact') === -1) return;
  
  // Find text nodes in <main> that look like raw CSS
  function wrapLeakedCSS(){
    var main = document.getElementById('MainContent');
    if(!main) return;
    
    // Walk text nodes and find leaked CSS
    var walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, null, false);
    var leakedNodes = [];
    var node;
    while((node = walker.nextNode())){
      // Raw CSS typically starts with .class{ or contains { at high density
      var txt = node.textContent;
      if(txt.indexOf('.page-hero{') !== -1 || txt.indexOf('.contact-layout{') !== -1){
        leakedNodes.push(node);
      }
    }
    
    leakedNodes.forEach(function(n){
      // Wrap the leaked CSS in a style tag
      var style = document.createElement('style');
      style.textContent = n.textContent;
      n.parentNode.replaceChild(style, n);
    });
    
    if(leakedNodes.length > 0){
      console.log('[Xcard] Fixed ' + leakedNodes.length + ' leaked CSS node(s) on contact page');
    }
  }
  
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', wrapLeakedCSS);
  } else {
    wrapLeakedCSS();
  }
})();

/* ═══ HEADER LOGO FIX v2 — force PNG, hide SVG/text ═══ */
(function(){
  var LOGO_URL = 'https://cdn.shopify.com/s/files/1/0770/8665/4642/t/4/assets/xcard-logo-horizontal.png';

  function fixHeaderLogo(){
    var logoEl = document.querySelector('.xc-header__logo');
    if(!logoEl) return;
    var hasImg = logoEl.querySelector('img');
    if(hasImg){
      // Already has img tag — just hide any leftover SVG/text siblings
      var mark = logoEl.querySelector('.xc-logo-mark');
      var txt  = logoEl.querySelector('.xc-logo-text');
      if(mark) mark.style.cssText = 'display:none!important;visibility:hidden!important;width:0!important;height:0!important;overflow:hidden!important';
      if(txt)  txt.style.cssText  = 'display:none!important;visibility:hidden!important;width:0!important;height:0!important;overflow:hidden!important';
    } else {
      // No img — replace entire inner HTML with PNG img
      logoEl.innerHTML = '<img src="'+LOGO_URL+'" alt="Xcard HK" width="160" height="36" style="height:36px;width:auto;object-fit:contain;display:block;filter:brightness(1.1)" loading="eager">';
    }
  }

  function fixMobileLogo(){
    var mLogo = document.querySelector('.xc-mobile-nav__logo');
    if(!mLogo) return;
    var hasImg = mLogo.querySelector('img');
    if(hasImg){
      var svgEl  = mLogo.querySelector('svg');
      var spanEl = mLogo.querySelector('span');
      if(svgEl)  svgEl.style.cssText  = 'display:none!important;visibility:hidden!important';
      if(spanEl) spanEl.style.cssText = 'display:none!important;visibility:hidden!important;width:0!important';
    } else {
      mLogo.innerHTML = '<img src="'+LOGO_URL+'" alt="Xcard HK" width="140" height="28" style="height:28px;width:auto;object-fit:contain;display:block;filter:brightness(1.1)">';
    }
  }

  function applyLogoFixes(){
    fixHeaderLogo();
    fixMobileLogo();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', applyLogoFixes);
  } else {
    applyLogoFixes();
  }
})();

/* ── HAMBURGER MENU FIX v1777979103 — JS CSS injection (bypasses all cache) ── */
(function() {
  function injectHamburgerFix() {
    // 只在手機版 (<= 900px) 執行
    if (window.innerWidth > 900) return;
    
    var styleId = 'xc-hamburger-fix';
    if (document.getElementById(styleId)) return;
    
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '@media (max-width: 900px) {',
      '  .xc-header__inner { padding: 0 8px 0 16px !important; box-sizing: border-box !important; width: 100% !important; overflow: visible !important; display: flex !important; align-items: center !important; gap: 8px !important; max-width: 100% !important; }',
      '  .xc-header__actions { gap: 4px !important; flex-shrink: 0 !important; overflow: visible !important; margin-right: 0 !important; padding-right: 0 !important; max-width: none !important; }',
      '  .xc-header__mobile-btn { display: flex !important; flex-shrink: 0 !important; margin-right: 0 !important; padding: 8px !important; min-width: 36px !important; visibility: visible !important; opacity: 1 !important; overflow: visible !important; }',
      '  .xc-header__curr { display: none !important; }',
      '  .xc-header__lang { display: none !important; }',
      '  .xc-icon-btn { width: 34px !important; height: 34px !important; padding: 6px !important; flex-shrink: 0 !important; min-width: 34px !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
    
    // 驗證修復效果
    var btn = document.getElementById('xcMobileMenuBtn');
    if (btn) {
      var rect = btn.getBoundingClientRect();
      var vw = window.innerWidth;
      if (rect.right > vw) {
        // 按鈕還是超出邊界，強制用 inline style
        var inner = document.querySelector('.xc-header__inner');
        var actions = document.querySelector('.xc-header__actions');
        if (inner) inner.style.cssText = 'padding:0 8px 0 16px!important;box-sizing:border-box!important;width:100%!important;overflow:visible!important;gap:8px!important;';
        if (actions) actions.style.cssText = 'gap:4px!important;flex-shrink:0!important;overflow:visible!important;margin-right:0!important;';
        btn.style.cssText = 'display:flex!important;flex-shrink:0!important;margin-right:0!important;padding:8px!important;min-width:36px!important;visibility:visible!important;overflow:visible!important;';
      }
    }
  }
  
  // 立即執行 + DOMContentLoaded + window.onload 三重保障
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectHamburgerFix);
  } else {
    injectHamburgerFix();
  }
  window.addEventListener('load', injectHamburgerFix);
  window.addEventListener('resize', injectHamburgerFix);
})();
